module.exports = __webpack_public_path__ + "static/media/liga-thumb.733efcc7.png";